import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from './loading.service';

/**
 * Jeton de contexte pour exclure une requête du loading global.
 *
 * Usage : `http.get(url, { context: new HttpContext().set(SKIP_LOADING, true) })`
 * — utile pour le polling, l'autocomplétion ou toute requête d'arrière-plan
 * qui ne doit pas déclencher la barre de progression.
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

/** Incrémente le LoadingService pendant chaque requête HTTP (sauf opt-out). */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_LOADING)) {
    return next(req);
  }

  const loading = inject(LoadingService);
  loading.start();

  return next(req).pipe(finalize(() => loading.stop()));
};
